import React, { useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDocumentData } from "react-firebase-hooks/firestore";
import * as firebase from "firebase/app";
import { Dropdown } from "react-bootstrap";

const MatesList = (props) => {
  const [chatInfo] = useDocumentData(
    firebase.firestore().doc(`chats/${props.chatId}`)
  );

  let dateString;

  if (chatInfo && chatInfo.date) {
    let dateNow = new Date();
    let chatDate = new Date(chatInfo.date);

    let difDate = dateNow - chatDate;
    difDate = difDate.toString().slice(0, -3);

    if (difDate < 5) {
      dateString = "A l'instant";
    } else if (difDate < 60) {
      dateString = "Il y a " + difDate + " Sec";
    } else if (difDate < 3600) {
      dateString = "Il y a " + Math.round(difDate / 60) + " Min";
    } else if (difDate < 86400) {
      dateString = "Il y a " + Math.round(difDate / 3600) + " H";
    } else {
      dateString = "Il y a " + Math.round(difDate / 86400) + " J";
    }
  }

  const leaveChat = useCallback(() => {
    let i = 0;

    let usersTab = chatInfo.users;

    usersTab.forEach((user) => {
      if (user.id === props.userId) {
        usersTab.splice(i, 1);

        firebase.firestore().doc(`chats/${props.chatId}`).update({
          users: usersTab,
        });
      }
      i++;
    });

    let userMatesTab = props.userMates;
    i = 0;
    userMatesTab.forEach((mate) => {
      if (mate === props.chatId) {
        userMatesTab.splice(i, 1);
        firebase.firestore().doc(`users/${props.userId}`).update({
          mates: userMatesTab,
        });
      }
      i++;
    });

    const decrement = firebase.firestore.FieldValue.increment(-1);
    firebase.firestore().doc(`posts/${chatInfo.id_post}`).update({
      user_nbr: decrement,
    });
  }, [chatInfo, props]);

  let url = useLocation();

  return (
    <>
      {chatInfo && (
        <li
          className={`mates__el ${
            url.pathname.substr(5, 4) === "chat" &&
            url.pathname.substr(10) === props.chatId &&
            "mates__el--focus"
          } `}
        >
          <Link to={`/app/chat/${props.chatId}`}>
            <div className="mates__avatar">
              <img
                src={require(`../../../assets/img/${chatInfo.vignette}`)}
                alt="vignette chat"
              />
            </div>

            <div className="mates__content">
              <span className="mates__pseudo" title={chatInfo.chatTitle}>
                {chatInfo.chatTitle.substring(0, 16)}
              </span>
              <div className="mates__lastmsg" title={chatInfo.last_message}>
                <p>
                  {chatInfo.last_message &&
                    chatInfo.last_message.substring(0, 14)}
                  ...
                </p>
                <span className="mates__date">{dateString}</span>
              </div>
            </div>
          </Link>

          <Dropdown className="btn--options">
            <Dropdown.Toggle as="button">
              <span></span>
              <span></span>
              <span></span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item as="button" onClick={() => leaveChat()}>
                Quitter
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </li>
      )}
    </>
  );
};

export default MatesList;
